import { render, staticRenderFns } from "./ProductListing.vue?vue&type=template&id=b15afda6&"
import script from "./ProductListing.vue?vue&type=script&lang=js&"
export * from "./ProductListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports